import React from "react";
import { Link } from "react-router-dom";

import { ABOUT_US } from "../../constant/routes";
import { Logo } from "../common/svg";

import bg from "../../static/images/landingpage/explorer/thue_xe_co_tai_xe_tphcm_gia_re.png";

const AboutUs = () => {
	return (
		<div className="explorer-section">
			<div className="m-container">
				<div className="explorer-container">
					<div className="explorer-item">
						<div className="explorer-item__img">
							<img loading="lazy" src={bg} alt="thue_xe_co_tai_xe_tphcm_gia_re" />
						</div>
						<div className="explorer-item__content">
							<div className="wrap-svg">
								<Logo />
							</div>
							<h2>
								Bạn muốn biết thêm
								<br />
								về Mioto?
							</h2>
							<p>
								Mioto kết nối khách hàng có nhu cầu thuê xe với hàng ngàn chủ xe ô tô ở TPHCM, Hà Nội &amp; các tỉnh
								thành khác. Mioto hướng đến việc xây dựng cộng đồng người dùng ô tô văn minh &amp; uy tín tại Việt Nam.
							</p>
							<div className="wrap-btn">
								<Link to={ABOUT_US} className="btn btn--m btn-primary">
									Tìm hiểu thêm
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AboutUs;
